import React, { Component } from "react";

import AppContext from "../../../appContext";
import Logout from "../logout";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Box,
  Typography,
  Menu,
  Button,
  IconButton,
  Divider,
} from "@material-ui/core";

const styles = (theme) => ({
  avatarButton: {
    padding: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  avatar: {
    width: 38,
    height: 38,
    cursor: "pointer",
  },
  menu: {
    "& .MuiPaper-root": {
      borderRadius: 10,
      boxShadow: "0px 0px 17px -1px rgba(0, 0, 0, 0.45)",
      width: 320,
      marginTop: 8,
    },
  },
  menuContent: {
    padding: "12px 16px",
  },
  profileSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 16,
  },
  avatarLarge: {
    width: 80,
    height: 80,
    marginBottom: 12,
  },
  userName: {
    fontWeight: 600,
    fontSize: "1.125rem",
    color: "#00518b",
    textAlign: "center",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  userEmail: {
    fontSize: "0.8125rem",
    color: "#666",
    textAlign: "center",
    marginTop: 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  button: {
    backgroundColor: "#00518b",
    color: "#fff",
    borderRadius: 50,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.875rem",
    padding: "8px 16px",
    marginTop: 8,
    "&:hover": {
      backgroundColor: "#003d68",
      color: "#f0f0f0",
    },
  },
  divider: {
    margin: "12px 0",
  },
});

class UserMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    UserMenu.contextType = AppContext;
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  render() {
    const { classes, acessaGestaoPapeis, hasMinhaOtica } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <>
        <IconButton
          className={classes.avatarButton}
          onClick={this.handleClick}
          disableRipple
        >
          <Avatar
            className={classes.avatar}
            src={this.context.avatar || undefined}
            alt={this.context.userSession?.nome || "Usuário"}
          >
            {!this.context.avatar && this.context.userSession?.nome?.charAt(0)}
          </Avatar>
        </IconButton>

        <Menu
          className={classes.menu}
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box className={classes.menuContent}>
            <Box className={classes.profileSection}>
              <Avatar
                className={classes.avatarLarge}
                src={this.context.avatar || undefined}
                alt={this.context.userSession?.nome || "Usuário"}
              >
                {!this.context.avatar && this.context.userSession?.nome?.charAt(0)}
              </Avatar>
              <Typography className={classes.userName}>
                {this.context.userSession?.nome}
              </Typography>
              <Typography className={classes.userEmail}>
                {this.context.userSession?.email}
              </Typography>
            </Box>

            <Button
              component={Link}
              to="/profile"
              onClick={this.handleClose}
              className={classes.button}
              fullWidth
              variant="contained"
              disableElevation
            >
              Meu perfil
            </Button>

            {(hasMinhaOtica() || acessaGestaoPapeis()) && (
              <Divider className={classes.divider} />
            )}

            {hasMinhaOtica() && (
              <Button
                component={Link}
                to="/empresa"
                onClick={this.handleClose}
                className={classes.button}
                fullWidth
                variant="contained"
                disableElevation
              >
                Minha Empresa
              </Button>
            )}

            {hasMinhaOtica() && acessaGestaoPapeis() && (
              <Divider className={classes.divider} />
            )}

            {acessaGestaoPapeis() && (
              <Button
                component={Link}
                to="/roles"
                onClick={this.handleClose}
                className={classes.button}
                fullWidth
                variant="contained"
                disableElevation
              >
                Gestão de Papéis
              </Button>
            )}

            <Divider className={classes.divider} />

            <Logout />
          </Box>
        </Menu>
      </>
    );
  }
}

export default withStyles(styles)(UserMenu);
